import React, {Component} from 'react';
import {connect} from 'react-redux';
import { Form, Input, Checkbox, Button, Row, Col, notification } from 'antd';
import {registerApplication} from '../actions';
const FormItem = Form.Item;

class RegistrationForm extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            serverErrors: null
        }
    }
    static getDerivedStateFromProps(nextProps, prevState) {
        if (nextProps.error) {
            return {serverErrors: nextProps.error}
        }
        if (!nextProps.error && prevState.serverErrors) {
            return {serverErrors: null}
        }
        return null;
    }
    static notify(args){
        const {type, ...rest} = args;
        notification[type]({
            ...rest,
            placement: 'bottomRight'
        });
    }
    static notifyError() {
        RegistrationForm.notify({
            type: 'error',
            message: 'Submission failed',
            description: 'There could be some validation errors on posted data. Please try again once corrected.'
        })
    }
    static notifySuccess() {
        RegistrationForm.notify({
            type: 'success',
            message: 'Success',
            description: 'Enquire successfully submitted to the system.'
        })
    }
    handlePostSubmit(values) {
        const {state: {serverErrors}, props: {form}} = this;
        if (!serverErrors) {
            form.resetFields();
            RegistrationForm.notifySuccess();
            return;
        }

        const {res: {errors}} = serverErrors;
        const fields = {};
        Object.keys(errors).forEach(field => {
            const errs = errors[field];
            fields[field] = {
                value: values[field],
                errors: errs.map(err => new Error(err))
            }
        });
        form.setFields(fields);
        RegistrationForm.notifyError();
    }
    handleSubmit(e){
        e.preventDefault();
        const {form, registerApplication} = this.props;
        return form.validateFieldsAndScroll((err, values) => {
            if (err) {
                return;
            }
            return registerApplication(values).then(() => this.handlePostSubmit(values));
        });
    }
    render() {
        const { getFieldDecorator, getFieldValue } = this.props.form;

        const formItemLayout = {
            labelCol: {
                xs: { span: 24 },
                sm: { span: 6 },
            },
            wrapperCol: {
                xs: { span: 24 },
                sm: { span: 18 },
            },
        };
        const tailFormItemLayout = {
            wrapperCol: {
                xs: {
                    span: 24,
                    offset: 0,
                },
                sm: {
                    span: 18,
                    offset: 6,
                },
            },
        };

        return (
            <Row style={{ marginTop: '10px' }} gutter={16}>
                <Col span={16} offset={4}>
                    <Form onSubmit={this.handleSubmit.bind(this)} id="registration">
                        <FormItem hasFeedback
                            {...formItemLayout}
                            label={(
                                <span>Business Name</span>
                            )}
                        >
                            {getFieldDecorator('business_name', {
                                rules: [{ required: true, message: 'Please input your business name!', whitespace: true }],
                            })(
                                <Input style={{height: 50, borderRadius: 0, fontSize: 22}}/>
                            )}
                        </FormItem>

                        <FormItem hasFeedback
                            {...formItemLayout}
                            label="Address Line 1"
                        >
                            {getFieldDecorator('address_line_1', {
                                rules: [{ required: true, message: 'Please input your address line 1', whitespace: true }],
                            })(
                                <Input style={{height: 50, borderRadius: 0, fontSize: 22}} />
                            )}
                        </FormItem>

                        <FormItem hasFeedback
                            {...formItemLayout}
                            label="Address Line 2"
                        >
                            {getFieldDecorator('address_line_2', {
                                rules: [{ required: true, message: 'Please input your address line 2', whitespace: true }],
                            })(
                                <Input style={{height: 50, borderRadius: 0, fontSize: 22}} />
                            )}
                        </FormItem>

                        <FormItem hasFeedback
                            {...formItemLayout}
                            label="Address Line 3"
                        >
                            {getFieldDecorator('address_line_3', {
                                rules: [{ required: false, message: 'Please input your address line 3', whitespace: true }],
                            })(
                                <Input style={{height: 50, borderRadius: 0, fontSize: 22}} />
                            )}
                        </FormItem>

                        <FormItem hasFeedback
                            {...formItemLayout}
                            label="Post Code"
                        >
                            {getFieldDecorator('post_code', {
                                normalize: value => {
                                    if (!value) return "";
                                    return value.replace(/[ ]+/g, '')
                                        .replace(/([A-Za-z]{1,2}[0-9Rr][0-9A-Za-z]?)([0-9][ABD-HJLNP-UW-Zabd-hjlnp-uw-z]{2})/, "$1 $2")
                                        .toUpperCase();
                                },
                                rules: [
                                    { pattern: '[A-Za-z]{1,2}[0-9Rr][0-9A-Za-z]? [0-9][ABD-HJLNP-UW-Zabd-hjlnp-uw-z]{2}', message: 'Invalid post code', transform: value => {
                                        return value.replace(/[ ]+/g, '')
                                            .replace(/([A-Za-z]{1,2}[0-9Rr][0-9A-Za-z]?)([0-9][ABD-HJLNP-UW-Zabd-hjlnp-uw-z]{2})/, "$1 $2");
                                    }},
                                    { required: true, message: 'Please input your post code', whitespace: true }
                                ],
                            })(
                                <Input style={{height: 50, borderRadius: 0, fontSize: 22}} />
                            )}
                        </FormItem>

                        <FormItem hasFeedback
                            {...formItemLayout}
                            label="Main Contact Name"
                        >
                            {getFieldDecorator('contact_name', {
                                rules: [{ required: true, message: 'Please input your main contact name', whitespace: true }],
                            })(
                                <Input style={{height: 50, borderRadius: 0, fontSize: 22}} />
                            )}
                        </FormItem>

                        <FormItem hasFeedback
                            {...formItemLayout}
                            label="Phone Number"
                        >
                            {getFieldDecorator('phone_number', {
                                rules: [
                                    { pattern: /\d{11}$/, message: 'Invalid phone number' },
                                    { required: true, message: 'Please input your phone number!', whitespace: true }
                                ],
                            })(
                                <Input style={{ width: '100%', height: 50, borderRadius: 0, fontSize: 22 }} />
                            )}
                        </FormItem>

                        <FormItem hasFeedback
                            {...formItemLayout}
                            label="E-mail"
                        >
                            {getFieldDecorator('email', {
                                rules: [{
                                    type: 'email', message: 'The input is not valid E-mail!',
                                }, {
                                    required: true, message: 'Please input your E-mail!', whitespace: true,
                                }],
                            })(
                                <Input style={{height: 50, borderRadius: 0, fontSize: 22}} />
                            )}
                        </FormItem>

                        <FormItem
                            {...formItemLayout}
                            label="Gas Safe Registered?"
                            colon={false}
                        >
                            {getFieldDecorator('gas_safe_registered', {
                                initialValue: false,
                            })(
                                <Checkbox style={{
                                    transform: 'scale(2)',
                                    marginLeft: 6,
                                    lineHeight: '46px',
                                }}/>
                            )}
                        </FormItem>

                        {getFieldValue('gas_safe_registered') ? (
                            <FormItem hasFeedback
                                {...formItemLayout}
                                label="Gas Safe Registration No"
                            >
                                {getFieldDecorator('gas_safe_registration_no', {
                                    rules: [{
                                        message: 'Please input your Gas Safe registration number', whitespace: true,
                                    }],
                                })(
                                    <Input style={{height: 50, borderRadius: 0, fontSize: 22}} />
                                )}
                            </FormItem>
                        ) : null }

                        <FormItem {...tailFormItemLayout}>
                            <Button type="primary" htmlType="submit" style={{width: '100%', height: 50, fontSize: 22, borderRadius: 0}}>Submit</Button>
                        </FormItem>
                    </Form>
                </Col>
            </Row>
        );
    }
}

const WrappedRegistrationForm = Form.create()(RegistrationForm);
function mapStateToProps(state, ownProps) {
    return Object.assign({}, state.register);
}
export default connect(mapStateToProps, {registerApplication})(WrappedRegistrationForm);


// WEBPACK FOOTER //
// ./resources/assets/js/components/Enquire.js